import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, MessageCircle } from "lucide-react";
import { Logo } from "../Logo";
import { useLang } from "../../lib/ctx";
import { api, errMsg } from "../../lib/api";

export const Newsletter = () => {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!consent) return toast.error(t("consent"));
    try {
      await api.post("/newsletter", { email, consent });
      toast.success("Subscribed. Welcome to the Inner Circle.");
      setEmail("");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <section className="relative overflow-hidden border-y border-white/10 bg-[#1B1B1B] grain">
      <div className="relative z-10 mx-auto grid max-w-7xl gap-8 px-4 py-20 sm:px-8 lg:grid-cols-2 lg:px-12">
        <div>
          <p className="eyebrow">Newsletter</p>
          <h2 className="mt-3 font-display text-5xl sm:text-6xl">{t("newsletter")}</h2>
          <p className="mt-3 max-w-md text-zinc-400">{t("newsletterSub")}</p>
        </div>
        <form onSubmit={submit} className="self-end" data-testid="newsletter-form">
          <div className="flex">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="field" data-testid="newsletter-email-input" />
            <button className="btn-gold" data-testid="newsletter-submit-btn">{t("subscribe")}</button>
          </div>
          <label className="mt-3 flex items-start gap-2 text-xs text-zinc-400">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} data-testid="newsletter-consent-checkbox" className="mt-0.5 accent-[#C8A45D]" />
            {t("consent")}
          </label>
        </form>
      </div>
    </section>
  );
};

const COLS = [
  ["Shop", [["shop", "/shop"], ["vintage", "/shop/vintage"], ["topup", "/game-top-up"], ["newArrivals", "/new-arrivals"], ["offers", "/special-offers"]]],
  ["Help", [["track", "/track-order"], ["faqs", "/faqs"], ["shippingPolicy", "/shipping-policy"], ["returns", "/returns"], ["contactUs", "/contact"]]],
  ["DDV", [["about", "/about"], ["blog", "/blog"], ["privacy", "/privacy"], ["terms", "/terms"]]],
];

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#080808]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-8 md:grid-cols-5 lg:px-12">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-5 max-w-sm text-sm text-zinc-400">{t("footerTag")}</p>
          <div className="mt-6 space-y-2 text-sm text-zinc-300">
            <a href="https://wa.me/60123655966" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#C8A45D]" data-testid="footer-whatsapp-link"><MessageCircle className="h-4 w-4" /> +60 12-365 5966</a>
            <a href="mailto:danishdaniyal159@gmail.com" className="flex items-center gap-2 hover:text-[#C8A45D]" data-testid="footer-email-link"><Mail className="h-4 w-4" /> danishdaniyal159@gmail.com</a>
            <p className="text-zinc-500">Malaysia · ddvintage.co</p>
          </div>
        </div>
        {COLS.map(([h, links]) => (
          <div key={h}>
            <p className="eyebrow mb-4">{h}</p>
            <ul className="space-y-2">
              {links.map(([k, to]) => <li key={k}><Link to={to} className="text-sm text-zinc-400 transition-colors duration-200 hover:text-white" data-testid={`footer-${k}-link`}>{t(k)}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="gold-line" />
      <p className="py-6 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">© {new Date().getFullYear()} DDVINTAGE CO · All prices in MYR</p>
    </footer>
  );
};
